import { Form } from 'semantic-ui-react';
import styled from 'styled-components';

const DrawerFooter = styled(Form.Field)`
  margin-top: 3rem !important;
`;

const BankBox = styled.div`
  box-shadow: 0px 3px 20px #0000000b;
  position: relative;
  border-radius: 0.375rem;
  border-color: transparent;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: #ffffff;

  .bank-box-header {
    display: flex;
    align-items: center;
    margin-bottom: 1rem;
  }

  .bank-logo {
    position: relative;
    width: 3rem;
    height: 3rem;
    flex: none;
    overflow: hidden;
    border-radius: 0.375rem;
    align-items: center;
    justify-content: center;
    text-align: center;
    display: flex;
    background: #e5e7eb;
    font-weight: bold;
  }

  .bank-content {
    margin-right: auto;
    margin-left: 1rem;

    .bank-name {
      font-weight: 600;
    }
  }

  .bank-accounts-counter {
    cursor: pointer;
    padding-top: 0.25rem;
    padding-bottom: 0.25rem;
    padding-left: 0.5rem;
    padding-right: 0.5rem;
    font-size: 0.75rem;
    line-height: 1rem;
    font-weight: 600;
    color: #ffffff;
    border-radius: 9999px;
    background: rgb(13 148 136);
  }

  .bank-options {
    margin-left: 2rem;

    &:hover button {
      background: none !important;
    }
  }
`;

export const BankEl = {
  DrawerFooter,
  BankBox
};
